import React              from "react";
import { useTranslation } from "react-i18next";

import Render     from "_components/atoms/render";
import Typography from "_components/atoms/typography";
import VideoCard  from "_components/organisms/videoCardList/videoCard";
import useStyles  from "_styles/templates/RecommendedSessions";

import Ads from "./ads";

export default function RecommendedSessions ( props ) {

	const { classes } = useStyles ( undefined, { name: "RecommendedSessions" } );
	const { t }       = useTranslation ();

	const {
		sessions = [],
		showAds
	} = props;

	return (
		<div style = { { flex: 4 } }>
			<div className = { `flex alignItemsCenter ${ classes.titleContainer }` }>

				<Typography
					title  = { t ( "streams_like" ) }
					weight = { 500 }
				/>
			</div>

			<div className = { classes.videoListContainer }>
				{
					sessions.filter ( session => session.broadcastId !== props?.broadcastId ).map ( ( item, index ) => {
						return (
							<React.Fragment key = { index }>
								<Render condition = { showAds }>
									<Ads idx = { index } />
								</Render>

								<VideoCard
									key                 = { item.id }
									activeTab           = { "" }
									data                = { item }
									from                = ""
									fromRecommendations = { true }
									hideMenuOptions     = { !props?.isMobile }
									isMobile            = { props?.isMobile }
									isWithoutAnimation  = { true }
								/>
							</React.Fragment>
						);
					} )
				}
			</div>

			{/* <VideoCardList list = { sessions.filter ( session => session.broadcastId !== props?.broadcastId ) } /> */}

		</div>
	);
}
